export class CustomErrorResponse {
  message: string;
  description: string;
  detail: string;
  isWarning: boolean = false;
}
